import React, { useState, useEffect, useRef } from 'react';
import { gql, useQuery } from '@apollo/client';
import BarraNavegacion from './BarraNavegacion';
import '../App.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShoppingCart } from '@fortawesome/free-solid-svg-icons';

const GET_PRODUCTOS = gql`
  query getProductos {
    getProductos {
      _id
      nombre
      imagen
      codigo
      precio
      stock
    }
  }
`;

function GetProductosLegumbre() {
  const [carrito, setCarrito] = useState([]);
  const [total, setTotal] = useState(0);
  const [cantidades, setCantidades] = useState({});
  const [indiceSeleccionado, setIndiceSeleccionado] = useState(0); // Estado para la tarjeta seleccionada
  const { loading, error, data } = useQuery(GET_PRODUCTOS);

  const numColumnas = 5; // Número de columnas que tienes en cada fila

  // Crear un array de referencias para las tarjetas
  const cardRefs = useRef([]);

  useEffect(() => {
    const carritoGuardado = JSON.parse(localStorage.getItem('carrito')) || [];
    setCarrito(carritoGuardado);
  }, []);

  useEffect(() => {
    localStorage.setItem('carrito', JSON.stringify(carrito));
    recalcularTotal();
  }, [carrito]);

  const productosFiltrados = data?.getProductos
    ? data.getProductos
        .filter((producto) => producto.codigo === "1" || producto.codigo === "2")
        .sort((a, b) => a.nombre.localeCompare(b.nombre))
    : [];

  useEffect(() => {
    const manejarTeclas = (event) => {
      if (event.key === 'ArrowUp') {
        setIndiceSeleccionado((prevIndex) =>
          prevIndex - numColumnas >= 0 ? prevIndex - numColumnas : prevIndex
        );
      } else if (event.key === 'ArrowDown') {
        setIndiceSeleccionado((prevIndex) =>
          prevIndex + numColumnas < productosFiltrados.length ? prevIndex + numColumnas : prevIndex
        );
      } else if (event.key === 'ArrowLeft') {
        setIndiceSeleccionado((prevIndex) =>
          prevIndex > 0 ? prevIndex - 1 : prevIndex
        );
      } else if (event.key === 'ArrowRight') {
        setIndiceSeleccionado((prevIndex) =>
          prevIndex < productosFiltrados.length - 1 ? prevIndex + 1 : prevIndex
        );
      } else if (event.key === 'Enter') {
        agregarAlCarrito(productosFiltrados[indiceSeleccionado]);
      }
    };

    window.addEventListener('keydown', manejarTeclas);
    return () => {
      window.removeEventListener('keydown', manejarTeclas);
    };
  }, [indiceSeleccionado, productosFiltrados]);

  useEffect(() => {
    // Asegurarse de que la tarjeta seleccionada esté visible
    if (cardRefs.current[indiceSeleccionado]) {
      cardRefs.current[indiceSeleccionado].scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'nearest',
      });
    }
  }, [indiceSeleccionado]);

  const agregarAlCarrito = (producto) => {
    const cantidad = cantidades[producto._id] || 1;
    const productoEnCarrito = carrito.find((item) => item._id === producto._id);

    if (productoEnCarrito) {
      setCarrito((prevCarrito) =>
        prevCarrito.map((item) =>
          item._id === producto._id ? { ...item, cantidad: item.cantidad + cantidad } : item
        )
      );
    } else {
      setCarrito((prevCarrito) => [...prevCarrito, { ...producto, cantidad }]);
    }
  };

  const cambiarCantidadProducto = (productId, nuevaCantidad) => {
    setCantidades((prevCantidades) => ({
      ...prevCantidades,
      [productId]: nuevaCantidad,
    }));
  };

  const recalcularTotal = () => {
    const nuevoTotal = carrito.reduce((acc, producto) => {
      const subtotal = producto.codigo === "1"
        ? (producto.precio * producto.cantidad) + 200
        : producto.precio * producto.cantidad;
      return acc + subtotal;
    }, 0);
    setTotal(nuevoTotal);
  };

  if (loading) return <p>Cargando productos...</p>;
  if (error) return <p>Error al cargar los productos.</p>;

  return (
    <div>
      <BarraNavegacion />

      <a className='btn-carrito btn' href="ver-carrito">
        <FontAwesomeIcon icon={faShoppingCart} />
      </a>

      <div className="container">
        <div className="row">
          {productosFiltrados.map((producto, index) => (
            <div
              className={`card-legumbre col-2 ${indiceSeleccionado === index ? 'seleccionado' : ''}`} // Agregamos una clase si está seleccionada
              key={producto._id}
              ref={(el) => (cardRefs.current[index] = el)} // Referenciamos la tarjeta
            >
              <div className="card-body">
                <h6 className="card-title">{producto.nombre}</h6>
              
                <p className="card-text">  <img src={producto.imagen} width="35px" alt={producto.nombre} />
              
                  ${producto.codigo === "1" ? (producto.precio * 1000 + 200).toFixed(0) : producto.precio.toFixed(0)}
                </p>
                <p> <input
                  type="number"
                  min="1"
                  value={cantidades[producto._id] || 1}
                  onChange={(e) => cambiarCantidadProducto(producto._id, parseInt(e.target.value))}
                  style={{ width: '60px', marginRight: '10px' }}
                /> <button
                  className="btn btn-primary btn-legumbre"
                  onClick={() => agregarAlCarrito(producto)}
                >
                  Agregar
                </button></p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div>
        <h2>Total a pagar: ${total.toFixed(2)}</h2>
      </div>
    </div>
  );
}

export default GetProductosLegumbre;
